import {
    Button,
    Grid,
    Paper,
    TextField,
    FormHelperText,
    Typography
} from '@mui/material'

import qs from 'qs'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import { ROUTELOGIN, ROUTEHOME } from '../../routes'
import { AppState } from 'src/store'
import {
    addSnackbar,
    changePage
} from '../../actions'
import { Error } from 'src/domains/explorer/types';
import Header from '../components/Header';
import { changePageTitle } from '../../actions';

const renderErrors = (errors: { [key: string]: Error[] }, name: string) => {
    const errKey = '/' + name;
    return errors[errKey] && errors[errKey].map((err, index) => (
        <FormHelperText
            id={'field-error-' + name}
            key={index}
            sx={{ color: theme => theme.palette.error.main }}
        >
            {err.message}
        </FormHelperText>
    ))
};

const renderConfirmMessage = () => {
    return <Grid
        container
        direction='column'
        justifyContent='space-around'
        spacing={1}
    >
        <Typography>{'An email has been sent with account activation link, which you can use to confirm your email address and complete sign up process. It will expire in 30 minutes.'}</Typography>
    </Grid>
};

const Signup: React.FC = () => {
    const dispatch = useDispatch();
    const [username, setUsername] = useState(''); // user
    const [password, setPassword] = useState(''); // pass
    const [confirmPassword, setConfirmPassword] = useState(''); // pass
    const [errors, setErrors] = useState<{ [key: string]: Error[] }>({});
    const [signedUp, setSignedUp] = useState<boolean>(false);
    const location = useLocation();

    const apiEndpoint = useSelector((state: AppState) => state.global.options.baseUrl);

    useEffect(() => {
        dispatch(changePageTitle('Sign Up'));
    }, []);

    useEffect(() => {
        setUsername('');
        setPassword('');
        setConfirmPassword('');
        setErrors({});
        setSignedUp(false);
    }, [location.key]);

    const signUp = async () => {
        let endpoint = apiEndpoint + '/signup';

        let body = {
            email: username,
            password,
            confirmPassword,
        };

        let options: RequestInit = {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: qs.stringify(body),
        };

        try {
            let response = await fetch(endpoint, options)
            if (response.status === 200) {
                // const user: any = await response.json();
                dispatch(addSnackbar('Signup successful!', 'signupSuccess', {}));
                // setTimeout(() => {
                //     dispatch(changePage(ROUTELOGIN));
                // }, 1);
                setSignedUp(true);
            } else {
                dispatch(addSnackbar('Signup error!', 'signupError', {}));
                let text = await response.text();
                const data = JSON.parse(text);
                setErrors(data);
            }
        } catch (err) {
            dispatch(addSnackbar('Signup error!', 'signupError', {}));
        }

    }

    const cancel = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(ROUTEHOME));
    }

    return (<>
        <Header />
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: '100vh', backgroundColor: theme => theme.palette.grey[300] }}
        >

            <Grid size={3}>

                <Paper sx={{ p: 1 }}>
                    {!signedUp ? <>
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-around'
                            spacing={1}
                            marginBottom={1}
                        >
                            <Grid>
                                {
                                    errors['/'] && errors['/'].map((err, index) => (
                                        <FormHelperText key={index} error>
                                            {err.message}
                                        </FormHelperText>
                                    ))
                                }
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction='column'
                            justifyContent='space-around'
                            spacing={1}
                        >

                            <Grid>
                                <TextField
                                    size='small'
                                    label={'email'}
                                    fullWidth
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                                {
                                    renderErrors(errors, 'userKey')
                                }
                            </Grid>

                            <Grid>
                                <TextField
                                    size='small'
                                    label={'password'}
                                    fullWidth
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    inputProps={{
                                        type: 'password'
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            signUp()
                                        }
                                    }}
                                />
                                {
                                    renderErrors(errors, 'password')
                                }
                            </Grid>

                            <Grid>
                                <TextField
                                    size='small'
                                    label={'confirm password'}
                                    fullWidth
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    inputProps={{
                                        type: 'password'
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            signUp()
                                        }
                                    }}
                                />
                                {
                                    renderErrors(errors, 'confirmPassword')
                                }
                            </Grid>

                            <Grid>
                                <Grid
                                    container
                                    direction='row'
                                    alignItems='center'
                                    justifyContent='space-around'
                                >
                                    <Grid>
                                        <Button variant='outlined' size="small" onClick={cancel}>{'Cancel'}</Button>
                                    </Grid>
                                    <Grid>
                                        <Button variant='contained' size="small" onClick={signUp}>{'Submit'}</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </> : renderConfirmMessage()
                    }
                </Paper>
            </Grid>
        </Grid>
    </>)
}

export default Signup
